import apiService from '../services/apiServices';

export const getCampaigns = async () => {
  const response = await apiService.get(`/api/campaigns/`);
  return response;
};

export async function createCampaign(payload) {
  const response = await apiService.post(`/api/campaigns/`, payload);
  return response.data;
}

export async function updateCampaign(id, payload) {
  const response = await apiService.patch(`/api/campaigns/${id}/`, payload);
  return response.data;
}

export async function deleteCampaign(id) {
  const response = await apiService.delete(`/api/campaigns/${id}/`);
  return response.data;
}

export async function getCampaignById(id) {
  const response = await apiService.get(`/api/campaigns/${id}/`);
  return response;
}
